import './icon-styles.css';
import cx from 'classnames';
import React from 'react';
import styles from './icon.module.scss';
import { BASE_ICON_SPRITE_PATH, IconColor, IconID, IconSize } from './icon-constants';
import { appendSVGSprite, getIconPathFromIconID } from './icon-utils';

export { IconColor, IconID, IconSize } from './icon-constants';
export { appendSVGSprite };

export interface IconProps {
  /**
   * ID of the icon
   */
  id: IconID;
  /**
   * Icon Size
   *
   * @default IconSize.MEDIUM
   */
  size?: IconSize;
  /**
   * Icon Fill Color
   *
   * @default IconColor.BLACK
   */
  color?: IconColor;
  /**
   * Icon Stroke Color
   *
   * @default undefined None (no stroke color is applied)
   */
  strokeColor?: IconColor;
  /**
   * Any additional classnames for checkbox
   *
   * @default ''
   */
  className?: string;
  /**
   * For adding dynamic styles
   */
  style?: React.CSSProperties;
}

export const setupIconSprites = async () => {
  await appendSVGSprite(BASE_ICON_SPRITE_PATH, 'base-icon-sprite');
};

setupIconSprites();

export const Icon: React.FC<IconProps> = ({
  id,
  size = IconSize.MEDIUM,
  color = IconColor.BLACK,
  strokeColor,
  className = '',
  ...restProps
}: IconProps) => {
  const iconClass = cx(
    className,
    styles.iconStyle,
    styles[`${size}`],
    styles[`${color}`],
    strokeColor && styles[`stroke-${strokeColor}`]
  );
  return (
    <svg className={iconClass} {...restProps} data-radiant-v2>
      <use xlinkHref={getIconPathFromIconID(id)} />
    </svg>
  );
};
